import { BuyerVatInfo } from "@/framework/billing/buyerVatInfo";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { creditPriceLabel, creditValueOptions } from "./creditValueText";

type CreditValueDetailsProps = {
  credits: number;
  // Omitted while the buyer's country is unknown.
  vatInfo?: BuyerVatInfo;
};

export const CreditValueDetails = ({
  credits,
  vatInfo,
}: CreditValueDetailsProps) => {
  const options = creditValueOptions(credits);
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 1 }}>
        You pay {creditPriceLabel(credits, vatInfo)}.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Your account will be topped up with {credits} credits which is enough
        for one of the following:
      </Typography>
      <Box component="ul" sx={{ my: 0, pl: 3 }}>
        {options.map((option, index) => (
          <Typography component="li" key={option}>
            {option}
            {index == options.length - 1
              ? "."
              : index == options.length - 2
                ? ", or "
                : ", "}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
